import { useSettingsStore } from './SettingsStore.js';
export const useSettings = (keys) => {
    return useSettingsStore((state) => keys.reduce((values, key) => {
        values[key] = state[key];
        return values;
    }, {}));
};
//# sourceMappingURL=useSettings.js.map